import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import frc from 'front-end-common';
import rootReducer from '../Reducers';

const utilMiddleware = frc.utils.reducerTools.middleware;

export const history = createBrowserHistory();

function store (initialState = {}) {

  return configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore these action paths because they contain Promises
          // that are handled by our custom middleware
          ignoredActionPaths: ['payload'],
        },
      }).concat(utilMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
  });
};

export default store
